<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Kategorie dokumentów elektronicznych</span>
        <h3 class="page-title">Lista kategorii dokumentów elektronicznych</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button theme="success" @click.prevent="$router.push('/kategorie-dokumentow-elektronicznych/dodaj')">
          <i class="material-icons">add</i>
          Dodaj kategorię
        </d-button>
      </d-col>
    </d-row>
    <d-row
      v-if="loaded"
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <validation-observer
        ref="documents-category-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj id lub nazwę dokumentu"
          v-model="filters.search" />
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>

        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>
    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0">Nazwa kategorii</th>
          <th scope="col" class="border-0">Data utworzenia</th>
          <th scope="col" class="border-0">Akcje</th>
        </tr>
        </thead>
        <tbody v-if="loaded">
        <tr
          v-for="(category, index) of documentsCategory"
          :key="'user-' + index">
          <td class="align-middle">
            {{ category.name }}
          </td>
          <td class="align-middle">
            {{ category.created_at.slice(0, 10) }}
          </td>
          <td
            class="align-middle"
            style="width: 150px;">
            <d-button
              theme="primary"
              @click.prevent="$router.push('/kategorie-dokumentow-elektronicznych/edycja/' + category.id)"
              class="mr-2"
              title="Edytuj">
              <i class="material-icons">edit</i>
            </d-button>
            <d-button
              theme="danger"
              :disabled="removeInProgress"
              @click.prevent="removeCategory(category.id)"
              title="Usuń">
              <i class="material-icons">delete</i>
            </d-button>
          </td>
        </tr>
        <tr v-if="documentsCategory.length === 0">
          <td
            colspan="5"
            class="text-center">
            Brak dokumentów do wyświetlenia&hellip;
          </td>
        </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>

    <pagination :meta-data="paginationMetaData" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from '../../utils/FormUtils.js';
import HasFilters from '../../mixins/HasFilters.vue';
import HasPagination from '../../mixins/HasPagination.vue';
import ListUtils from '../../utils/ListUtils.js';
import Pagination from '../../components/common/Pagination.vue';

export default {
  name: 'EDocuments',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  data() {
    return {
      documentsCategory: [],
      loaded: false,
      loadError: false,
      removeInProgress: false,
      filters: {
        search: '',
      }
    };
  },
  mounted () {
    this.loadDocument();
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadDocument();
    }, 250),
    loadDocument () {
      let where = {
        search: this.filters.search
      };
      ListUtils.loadItemsData(this, {
        endpoint: '/edocuments/category/items?page=' + this.currentPage,
        listField: 'documentsCategory',
        pagination: true,
        params: {
          where
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: ''
      };

      this.loadDocument();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['documents-category-filters-form'], this.debouncedLoadFilteredData);
    },
    removeCategory (docCategoryID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/edocuments/category/delete/',
        id: docCategoryID,
        successTitle: 'Usunięto kategorię dokumentów',
        successText: 'Wybranay kategoria została usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć tą kategorię dokumentów?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie kategorii nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadDocument();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

